var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"alert"}},[(_vm.alert)?_c('div',{class:_vm.alert.type ? _vm.alert.type : 'error',attrs:{"id":"puzzle-alert"},domProps:{"innerHTML":_vm._s(_vm.alert.content ? _vm.alert.content : _vm.alert)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }